import "./notificationbox.css";
import axiosInstance from '../../config';
import { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import SocialContext from '../../context/SocialContext';
import Progress from '../Progress/Progress'
import { format } from "timeago.js";

export default function Profile({ notification }) {
  const navigate = useNavigate();
  const { setunreadnotification, unreadnotification, setuser: setcurrentuser, user: currentuser, showalert, scrolltoTopfun, isfetching } = useContext(SocialContext);
  const PF = "https://socialshub.netlify.app/images/";

  const [sender, setsender] = useState({})    // this is empty object // store profil's user details
  const [loading, setloading] = useState(false)
  const [read, setread] = useState(false)

  useEffect(() => {
    if (notification.read === true) {
      setread(true);
    }
  }, [])

  // for fetch sender's profile 
  useEffect(() => {
    const fetchUser = async () => {
      try {
        setloading(true);
        const response = await axiosInstance.get(`/api/users?userId=${notification.senderid}`);
        setsender(response.data);
        setloading(false);
      } catch (error) {
        console.log("errot inside profile ", error);
        navigate('*');
      }
    }
    fetchUser();
  }, []);

  // notificationClickfun
  const notificationClickfun = () => {
    const notificationtype = notification.notificationtype;
    const notificationid = notification.notificationid;
    if (notificationtype === "post") {
      navigate('/singlepost/'+notificationid);
    } else if (notificationtype === "follow") {
      navigate('/profile/'+notificationid);
    } 
  }

  return (
    <>
      {loading ? <Progress /> : <>
        {read == false && <div onClick={(e) => { notificationClickfun() }} className="notificationbox notread">
          <img src={sender.profilePic ? sender.profilePic : PF + "person/noprofile.png"} />
          <p><Link to={`/profile/${sender._id}`}>{sender.username}</Link> {notification.msg}</p>
          <span style={{ 'color': 'black' }}>{format(notification.createdAt)}</span>
          <span style={{ 'color': 'red' }}> new</span>
        </div>}
        {read == true && <div onClick={(e) => { notificationClickfun() }} className="notificationbox">
          <img src={sender.profilePic ? sender.profilePic : PF + "person/noprofile.png"} />
          <p><Link to={`/profile/${sender._id}`}>{sender.username}</Link> {notification.msg}</p>
          <span>{format(notification.createdAt)}</span>
        </div>}</>
      }
    </>
  );
}

